(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-rotating-logos"] && !Shopify.designMode) return;
  try {
    
  class RotatingLogos {
    constructor(container) {
      this.container = container;
      this.items = this.container.querySelectorAll('.logo-item');
      if (this.items.length <= 1) {
        if (this.items.length === 1) {
            this.items[0].style.display = 'block';
            this.items[0].classList.add('active');
        }
        return;
      }

      this.wrapper = this.container.closest('.rotating-logos-wrapper');
      this.speed = parseInt(this.wrapper.dataset.speed, 10) || 4000; // Default to 4000ms if not set
      this.currentIndex = 0;
      this.interval = null;

      this.init();
    }

    init() {
      // Show the first item immediately
      this.items.forEach(item => item.style.display = 'block'); // Ensure display is set for transitions
      this.items[this.currentIndex].classList.add('active');
      this.startRotation();
    }

    startRotation() {
       if (this.interval) {
        clearInterval(this.interval);
      }
      this.interval = setInterval(() => {
        // Hide current item
        this.items[this.currentIndex].classList.remove('active');

        // Calculate next index
        this.currentIndex = (this.currentIndex + 1) % this.items.length;

        // Show next item
        this.items[this.currentIndex].classList.add('active');
      }, this.speed);
    }
    
    destroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
  }

  // Use a Map to keep track of initialized instances
  const rotatingLogosInstances = new Map();

  function initRotatingLogosSection(sectionId) {
      const wrapper = document.querySelector(`.rotating-logos-wrapper[data-section-id="${sectionId}"]`);
      if (!wrapper) return;

      // If an instance for this section already exists, destroy it first
      if (rotatingLogosInstances.has(sectionId)) {
          rotatingLogosInstances.get(sectionId).destroy();
      }

      const container = wrapper.querySelector('.rotating-logos-container');
      if (container) {
          const instance = new RotatingLogos(container);
          rotatingLogosInstances.set(sectionId, instance);
      }
  }

  // Initial load for all sections
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.rotating-logos-wrapper').forEach(wrapper => {
        initRotatingLogosSection(wrapper.dataset.sectionId);
    });
  });

  // Re-initialize when the section is loaded or changed in the theme editor
  document.addEventListener('shopify:section:load', function(event) {
    initRotatingLogosSection(event.detail.sectionId);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const sectionId = event.detail.sectionId;
    if (rotatingLogosInstances.has(sectionId)) {
        rotatingLogosInstances.get(sectionId).destroy();
        rotatingLogosInstances.delete(sectionId);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
